export const MENU_OPEN = 'dalton/ui/MENU_OPEN'
export const MENU_CLOSE = 'dalton/ui/MENU_CLOSE'
export const MENU_TOGGLE = 'dalton/ui/MENU_TOGGLE'

export const defaultState = {
  menuOpen: true
}

export default function reducer (state = defaultState, action = {}) {
  switch (action.type) {
    case MENU_OPEN:
      return {
        ...state,
        menuOpen: true
      }

    case MENU_CLOSE:
      return {
        ...state,
        menuOpen: false
      }

    case MENU_TOGGLE:
      return {
        ...state,
        menuOpen: !state.menuOpen
      }

    default:
      return state
  }
}

export function openMenu () {
  return dispatch => dispatch({ type: MENU_OPEN })
}

export function closeMenu () {
  return dispatch => dispatch({ type: MENU_CLOSE })
}

export function toggleMenu () {
  return dispatch => dispatch({ type: MENU_TOGGLE })
}



// WEBPACK FOOTER //
// ./ducks/ui.js